<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>remove_red_eye</v-icon>Ver detalle solicitud
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md class="py-0" style="min-width: 100%;">
            <v-flex xs12>
              <h4>
                <strong>SERVIDOR PÚBLICO: </strong
                >{{ this.form.servidor_publico }}
              </h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="listado_funcionarios"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <!-- Cabecera -->
                  <template slot="headerCell" slot-scope="props">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="letra-cabecera">
                          {{ props.header.text }}
                        </span>
                      </template>
                      <span>
                        {{ props.header.text }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.secuencia }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>
                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cerrar
          </v-btn>

          <!-- <v-btn color="primary" @click.prevent="aprobarProgramacion()"
            ><v-icon>done</v-icon>
            Aprobar
          </v-btn> -->
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      listado_funcionarios: [],
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      lista_papeleta: [],
      headers: [
        {
          text: "Nro papeleta",
          sortable: false,
          align: "center",
          class: "cabecera"
        },
        { text: "Estado", sortable: false, align: "center", class: "cabecera" },
        {
          text: "Fecha desde",
          sortable: false,
          align: "center",
          class: "cabecera"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center",
          class: "cabecera"
        },
        {
          text: "Total dias",
          sortable: false,
          align: "center",
          class: "cabecera"
        }
      ],
      gestion: parseInt(this.$route.params.gestion),
      form: {}
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerDetalleSolicitudes", item => {
      this.form = item;
      this.cargarListadoFuncionario();

      this.dialog = true;
    });
  },

  methods: {
    async cargarListadoFuncionario() {
      try {
        let usuario = this.$storage.get("user").id_persona;
        let res = await this.$service.graphql({
          query: `
          query{
            vVacaProgramadas(id_persona:${this.form.id_persona},restriccion_estados:"9",gestion:"${this.gestion}"){
              count
              rows{
                id
                secuencia
                fecha_desde
                fecha_hasta
                id_estado
                fecha_solicitud
                id_unidad
                total_dias
                estado
                id_persona
                id_estado_vacacion
              }
            }
          }
          `
        });
        this.listado_funcionarios = res.vVacaProgramadas.rows;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.listado_funcionarios = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogVerDetalleSol");
      this.dialog = false;
    },

    async aprobarProgramacion() {
      let respuesta;
      let resps = [];
      let correcto = true;
      let user = this.$storage.get("user");

      this.loading = true;
      for (let i = 0; i < this.listado_funcionarios.length; i++) {
        const element = this.listado_funcionarios[i];

        try {
          respuesta = await this.$service.graphql({
            query: `
									query{
                                      runQuery(consulta:"select vacaciones.fn_aprueba_vacacion_programada_jefe(${element.id},${user.id_persona},${user.id})"){
                                        respuesta
                                      }
                                    }
								`
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_aprueba_vacacion_programada_jefe;
          resps = respuesta.split("|");

          correcto = resps[0];

          if (correcto === "1") {
            this.$message.success("La solicitud fue enviada correctamente");
          } else {
            this.$message.error(resps[1]);
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.loading = false;
      this.close();
      //	document.location.reload()
    }
  }
};
</script>

<style>
h4 {
  color: rgb(1, 3, 85);
}
.cabecera {
  white-space: pre;
  word-wrap: break-word;
  background: rgba(0, 165, 151, 0.438);
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
  border: 0em 0em 0em 0em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/VerDetalleSolicitudes.vue